interface UiErrorProps {
  msg?: string
}

function UiError({msg}: UiErrorProps) {
  return (
    <div className="container">
      <label>{msg}</label>
    </div>
  );
}

export default UiError;